/* Keep approved Halloween story copy complete at every desktop viewport. */
(() => {
  const arrange = (hero) => {
    const copy = hero.querySelector('.cardc-halloween-hero__copy');
    if (!copy) return;
    const update = () => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        hero.style.removeProperty('min-height');
        return;
      }
      const style = getComputedStyle(copy);
      const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      const content = Array.from(copy.children).reduce((height, child) => {
        const childStyle = getComputedStyle(child);
        return height + child.getBoundingClientRect().height + parseFloat(childStyle.marginTop) + parseFloat(childStyle.marginBottom);
      }, 0);
      hero.style.minHeight = Math.ceil(padding + content + 2) + 'px';
    };
    update();
    let previousWidth = 0;
    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width ?? 0;
      if (Math.abs(width - previousWidth) > .5) {
        previousWidth = width;
        requestAnimationFrame(update);
      }
    });
    observer.observe(copy);
    window.addEventListener('resize', update, { passive: true });
    document.fonts?.ready.then(update).catch(() => {});
  };
  const init = () => document.querySelectorAll('.cardc-halloween-hero').forEach((hero) => {
    if (hero.dataset.hwLayoutReady) return;
    hero.dataset.hwLayoutReady = 'true';
    arrange(hero);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
